<template>
  <sui-card v-if="isVisilble">
    <div class="ui fluid image">
      <div v-if="showNewTag" class="ui red ribbon label rib">
        <i class="star icon"></i> Nuevo
      </div>
      <div
        v-if="localProduct.isCustomTag && !showNewTag && label"
        class="ui ribbon label rib"
        :style="getStyles(label)"
      >
        <i v-if="label.icon" :class="label.icon" class="icon"></i>
        {{ label.label }}
      </div>
      <a :href="imageObj.largeUrl" class="ui gray right corner label" download="test">
        <i class="save icon"></i>
      </a>
      <VueSlickCarousel v-bind="settings">
        <div v-for="(item, index) in carrouselImages" :key="'product-img-' + index">
          <img class="ui image" :src="item.imgUrl" alt="" @click="openGallery(index)" />
        </div>
      </VueSlickCarousel>
      <div class="container">
        <CoolLightBox
          :items="items"
          :index="imageIndex"
          @close="imageIndex = null"
          :closeOnClickOutsideMobile="true"
        />
      </div>
    </div>
    <sui-card-content>
      <sui-card-header>
        <span>{{ localProduct.name }}</span>
        <span v-if="showWholesalePrice && canSell" class="price">{{
          wholesalePrice | numeralFormat("$0,0.00")
        }}</span>
        <span v-else class="price" v-show="canSell">{{
          price | numeralFormat("$0,0.00")
        }}</span>
      </sui-card-header>
      <sui-card-meta>
        <span>{{ localProduct.brands[0].name }} </span>
        <span> {{ localProduct.color ? ` Color: ${localProduct.color}` : "" }}</span>
        <span class="right floated" v-if="showWholesalePrice && canSell">{{
          price | numeralFormat("$0,0.00")
        }}</span>
      </sui-card-meta>
      <sui-card-description>
        <p>
          {{ localProduct.description }}
        </p>
      </sui-card-description>
    </sui-card-content>
    <sui-card-content extra v-if="showStock">
      <div class="table-wrapper">
        <table class="ui very basic compact table unstackable">
          <thead>
            <tr>
              <th class="collapsing" scope="col">
                <span class="tallas">Tallas</span>
              </th>
              <th
                class="collapsing center aligned my-th"
                scope="col"
                v-for="stock in stocks"
                :key="stock._id"
              >
                <span class="tallas">{{ stock.attribute }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th class="collapsing" scope="row">
                <span class="tallas">Stock</span>
              </th>
              <td
                class="collapsing center aligned"
                v-for="stock in stocks"
                :key="stock._id"
              >
                <span class="tallas">{{ stock.stock }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </sui-card-content>
    <div class="ui buttons" v-if="canSell">
      <button class="ui gray button" @click="goToProductDetails" v-if="showDetailsButton">
        <i class="left aligned search icon"></i>
        Detalle
      </button>
      <button class="ui green button" @click="addToCart">
        <i class="left aligned cart icon"></i>
        Agregar
      </button>
    </div>
  </sui-card>
</template>

<script>
import moment from "moment";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

const DAYS_AS_ANEW = 5;

export default {
  name: "ProductItem",
  props: ["product", "isMatrix"],
  data: function () {
    return {
      imageIndex: null,
      settings: {
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 7000,
        cssEase: "linear",
        adaptiveHeight: true,
      },
      options: {
        fullscreenEl: false,
        zoomEl: true,
        arrowEl: false,
        counterEl: false,
        preloaderEl: false,
        tapToClose: true,
        tapToToggleControls: true,
        shareEl: false,
        shareButtons: [
          {
            id: "download",
            label: "Descargar Imagen",
            url: "{{raw_image_url}}",
            download: true,
          },
        ],
      },
    };
  },
  computed: {
    label: function () {
      return this.labels.find((l) => l._id === this.localProduct.tag);
    },
    labels: function () {
      return this.$store.getters["labels/getLabels"];
    },
    carrouselImages: function () {
      return this.product.images.map((i) => {
        return { imgUrl: i.url };
      });
    },
    imageObj: function () {
      if (this.localProduct.images.length > 0) {
        return this.localProduct.images[0];
      } else {
        return {
          thumbnailUrl: this.localProduct.image,
          url: this.localProduct.image,
          largeUrl: this.localProduct.image,
        };
      }
    },
    items: function () {
      return this.localProduct.images.map((img) => {
        return { src: img.largeUrl, thumb: img.thumbnailUrl };
      });
    },
    wholesalePrice: function () {
      if (!this.isMatrix) {
        return this.price - this.wholesaleDto;
      } else {
        return this.localProduct.wholesalePrice;
      }
    },
    wholesaleDto: function () {
      return this.$store.getters["application/getWholeSaleDto"];
    },
    price: function () {
      const shopId = this.shopId;

      if (!this.isMatrix) {
        if (this.localProduct.isLocal) {
          return this.localProduct.shops.find((s) => s.shopId === this.shopId).price;
        } else {
          const increment = this.$store.getters["prices/getIncrement"](
            this.localProduct.brands[0]._id
          );

          return this.localProduct.price + increment;
        }
      } else {
        return this.localProduct.price;
      }
    },
    localProduct: function () {
      return this.product;
    },
    stocks: function () {
      return this.product.stocks.filter((s) => s.stock > 0);
    },
    isVisilble: function () {
      if (this.product.stocks.find((s) => s.stock > 0)) {
        return true;
      }
      return false;
    },

    showNewTag: function () {
      if (this.localProduct.isNewProduct) {
        return true;
      } else {
        const date = moment(this.localProduct.createdOn).startOf("day");

        const current = moment().startOf("day");

        const days = moment.duration(current.diff(date)).asDays();

        return days <= DAYS_AS_ANEW;
      }
    },
    showDetailsButton: function () {
      return this.$store.getters["application/showDetailsButton"];
    },
    showStock: function () {
      return this.$store.getters["application/showStock"];
    },
    showWholesalePrice: function () {
      return this.$store.getters["application/showWholesalePrice"];
    },
    shopId: function () {
      return this.$store.getters["application/getId"];
    },
    canSell: function () {
      return this.$store.getters["application/canSell"];
    },
  },
  methods: {
    getStyles: function (label) {
      if (label)
        return `background-color: ${label.backColor} !important; color: ${label.textColor} !important;`;

      return "";
    },
    openGallery: function (idx) {
      this.imageIndex = idx;
    },
    addToCart: function () {
      this.$emit("addToCart", this.product._id, this.price, this.wholesalePrice);
    },
    goToProductDetails: function () {
      this.$emit("showProductDetails", this.product._id);
    },
  },
  components: {
    VueSlickCarousel,
    CoolLightBox,
  },
};
</script>

<style>
.price {
  color: #dc143c;
  float: right;
}
.price-wholesale {
  float: right;
}
.tallas {
  font-size: 12px !important;
}
.my-th {
  padding-left: 0.2em !important;
}
.rib {
  z-index: 1;
}
.my-gallery,
figure {
  margin: 0;
}

@media (min-width: 1025px) {
  .cool-lightbox__slide__img {
    width: auto !important;
    height: auto !important;
  }
}
</style>
